export enum GoogleCalendarSyncOwner {
  PROVIDER = "provider",
  TENANT = "tenant",
}

export enum EventCreateStatus {
  SUCCESS = "success",
  PARTIAL_SUCCESS = "partial_success",
}
